import PropTypes from 'prop-types';
import React from 'react';
import HotelContact from './HotelContact';

class HotelContacts extends React.Component {
  render() {
    const hotel = this.props.hotel;
    const contacts = [];
    hotel.contacts.forEach(contact => {
      contacts.push(<HotelContact key={contact.id} hotelId={hotel.id} contact={contact} />);
    });
    return (
      <div>
        <h4 className="hotel-detail-subhead">Hotel Contacts</h4>
        {contacts}
      </div>
    );
  }
}
HotelContacts.propTypes = {
  hotel: PropTypes.object.isRequired,
};
export default HotelContacts;



// WEBPACK FOOTER //
// src/components/HotelDetail/HotelContacts.js